var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCancel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "ig",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#505054"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5672 4.70127L10.5672 4.70129L7.999 7.26951L5.43078 4.70129L5.43075 4.70127C5.33386 4.6044 5.20246 4.54999 5.06546 4.54999C4.92845 4.54999 4.79705 4.6044 4.70016 4.70127L4.70011 4.70132C4.60324 4.79821 4.54883 4.92961 4.54883 5.06662C4.54883 5.20362 4.60324 5.33502 4.70011 5.43191L4.70013 5.43194L7.26835 8.00016L4.70013 10.5684L4.70011 10.5684C4.60324 10.6653 4.54883 10.7967 4.54883 10.9337C4.54883 11.0707 4.60324 11.2021 4.70011 11.299L4.70016 11.2991C4.79705 11.3959 4.92845 11.4503 5.06546 11.4503C5.20246 11.4503 5.33386 11.3959 5.43075 11.2991L5.43078 11.299L7.999 8.73081L10.5672 11.299L10.5672 11.2991C10.6641 11.3959 10.7955 11.4503 10.9325 11.4503C11.0695 11.4503 11.2009 11.3959 11.2978 11.299L11.2979 11.299C11.3948 11.2021 11.4492 11.0707 11.4492 10.9337C11.4492 10.7967 11.3948 10.6653 11.2979 10.5684L11.2979 10.5684L8.72965 8.00016L11.2979 5.43194L11.2979 5.43191C11.3948 5.33502 11.4492 5.20362 11.4492 5.06662C11.4492 4.92961 11.3948 4.79821 11.2979 4.70132L11.2978 4.70127C11.2009 4.6044 11.0695 4.54999 10.9325 4.54999C10.7955 4.54999 10.6641 4.6044 10.5672 4.70127Z",
    fill: "#979797",
    stroke: "#979797",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.45015f49.svg";
export { ForwardRef as ReactComponent };